//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,MultiSelect} from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import MasterService from './../../../services/masterdata.service';
import CONSTANT from './../../../../shared/constants/constant'
import Multiselect from 'vue-multiselect'
import { Validator } from 'vee-validate';
import CryptoJS from 'crypto-js';

export default {
  name: 'approvalHierarchy',
  components: {
    //VueElementLoading,
    Pagination,
    BasicSelect,
    Loader,
    CustomExpandableTable,
    Multiselect,
    Validator

  },
  data: function() {
    return {
      approvalObject: "client",
      data:[{

      }],
      selectedRoles:{
        text: '',
        value: ''
      },
      roleList :[],
      userList :[],
      userId :[],
      role:"",
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      form:{
        role:[],
        user:[],
      },
      ApprovelData:[],
      approvelData:[{
        roleId : '',
        roleError : '',
        userId : [],
        userList : [],
        userError  :'',
        isSendEmail : 0
      }],
      rolesList : [],
      createdby : '',
      buttonText : 'Save',
      intialapprovalData : []
    }
  },
  computed: {

  },
  async mounted() {
    await this.getUserRoles();
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail.email;
    // this.setSaveFormDetails();
    await this.getApprovalHierarchyRole();
  },
  methods: {
    async getUserRoles(){
      this.isLoading = true;
      let result = await MasterService.getRolesList();
      this.isLoading = false;
      if (result.data.code == 200) {
        this.rolesList = result.data.data.rows;
      }else {
        this.rolesList = [];
        this.$alert("Internal Server Error",'Approval Hierarchy', "error");
      }
    },
    async getUserAgainRole(role,index){
    this.isLoading = true;
      if (role == '') {
        return true;
      }
      let payload = {
        "roleid" : role
      }
    let result = await MasterService.getUseRagainRolesID(payload);
    this.isLoading = false;
      if (result.data.code == 200) {
        this.approvelData[index].userList = [];
        this.approvelData[index].userId = [];
        if (result.data.data.length != 0) {
          for (var i = 0; i < result.data.data.length; i++) {
            this.approvelData[index].userList.push({
              value : result.data.data[i].userid,
              text : result.data.data[i].fullname,
              mobileNumber : result.data.data[i].MobileNumber,
              oldDeliveryUserOrUserId : result.data.data[i].OldDeliveryUserOrUserId,
              email : result.data.data[i].email,
              username : result.data.data[i].username,
            })
          }
          this.approvelData[index].roleError = '';
          this.approvelData[index].userError = '';
        }else {
          this.approvelData[index].userList = [];
          this.approvelData[index].userId = [];
          this.approvelData[index].userError = '';
          this.approvelData[index].roleId = '';
          this.$alert("No user assign for this role select different role.",'Approval Hierarchy', "error");
        }
      }
    },
    addNewRow(index) {
      let isError = 0;
      for (var i = 0; i < this.approvelData.length; i++) {
        if (this.approvelData[i].roleId == '') {
          this.approvelData[i].roleError = "Please select Role.";
          isError = 1;
        }else {
          this.approvelData[i].roleError = '';
        }
        if (this.approvelData[i].userId.length == 0) {
          this.approvelData[i].userError = "Please select User.";
          isError = 1;
        }else {
          this.approvelData[i].userError = '';
        }
      }
      if (isError == 1) {
        return true;
      }
      this.approvelData.push({
        roleId : '',
        roleError : '',
        userId : [],
        userList : [],
        userError  :'',
        isSendEmail : 0
      });
    },
    deleteRow(index) {
      this.$confirm("Remove selected Approval Levels.",'','question').then(()=>{
        this.approvelData.splice(index, 1);
      });
    },
    clearForm() {
      this.currentPage =  1,
      this.totalPage = 0,
      this.totalCount = 0,
      this.pageLimit = 10,
      this.$validator.reset();
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    ShowApprovalObjectInput(){
    },
    async saveApprovalHierarchy(){
      this.isLoading = true;
      let payload = {};
      payload.userHierarchyData = [];
      payload.objectType = this.approvalObject;
      for (var i = 0; i < this.approvelData.length; i++) {
        let  levelObj = {};
        levelObj.levelNumber = i+1;
        levelObj.roleID = this.approvelData[i].roleId;
        for (var j = 0; j < this.rolesList.length; j++) {
          if (this.rolesList[j].roleid == this.approvelData[i].roleId) {
            levelObj.roleName = this.rolesList[j].rolename;
          }
        }
        let userInfo = [];
        for (var z = 0; z < this.approvelData[i].userId.length; z++) {
          let userInfoObj = {};
          userInfoObj.userID = parseInt(this.approvelData[i].userId[z].value);
          userInfoObj.userName = this.approvelData[i].userId[z].text;
          userInfoObj.userEmail = this.approvelData[i].userId[z].email;
          userInfo.push(userInfoObj);
        }
        levelObj.userInfo = userInfo;
        levelObj.status = 1;
        if (this.approvelData[i].isSendEmail == true) {
          levelObj.isSendEmail = 1;
        }else {
          levelObj.isSendEmail = 0;
        }

        payload.userHierarchyData.push(levelObj)
        payload.createdby = this.createdby
        payload.projectkey = 'cargoautoallocation'

      }
      let result = await MasterService.createHerarchyRole(payload);
      this.isLoading = false;
      if (result.data.code == 200) {
        this.$alert("Role created successfully",'Approval Hierarchy', "success");
        this.buttonText = 'Save';
        this.approvelData =[{
          roleId : '',
          roleError : '',
          userId : [],
          userList : [],
          userError  :''
        }];
        this.getApprovalHierarchyRole();
      }
    },
    removeUserError(data,index){
      if (data.length == 0) {
        this.approvelData[index].userError = 'Please select User.';
      }else {
        this.approvelData[index].userError = '';
      }

    },
    async setRole(roleId,index){
      for (var i = 0; i < this.approvelData.length; i++) {
        let isError = 0;
        if (this.approvelData[i].roleId == '') {
          this.approvelData[i].roleError = "Please select Role.";
          isError = 1;
        }else {
          this.approvelData[i].roleError = '';
          this.approvelData[index].userList = [];
          this.approvelData[index].userId = [];
          await this.getUserAgainRole(roleId,index);
        }
        if (isError == 1) {
          return true;
        }
      }

    },
    async getApprovalHierarchyRole(){
          try {
            let payload = {
              objectType: this.approvalObject,
              projectkey : 'cargoautoallocation'
            }
            this.isLoading = true;
            var getRoleList = [];
            await MasterService.getApprovalHierarchyRole(payload).then(async result =>{
              getRoleList = await result.data.data;
              if (getRoleList.length == 0) {
                this.buttonText = 'Save';
                this.approvelData =[{
                  roleId : '',
                  roleError : '',
                  userId : [],
                  userList : [],
                  userError  :'',
                  isSendEmail : 0
                }];
                this.intialapprovalData = [];
                this.isLoading = false;
                return true;
              }else {
                this.approvelData = [];
                this.intialapprovalData = getRoleList;
                this.buttonText = 'Update';
                for (var i = 0; i < getRoleList.length; i++) {
                  let getRoles = {};
                  getRoles.roleId = getRoleList[i].roleid;
                  getRoles.roleError = '';
                  getRoles.userList = getRoleList[i].userList;
                  getRoles.userId = getRoleList[i].userInfo;
                  getRoles.isSendEmail = getRoleList[i].isSendEmail;
                  getRoles.userError = '';
                 this.approvelData.push(getRoles);
                }
                this.isLoading = false;
              }
            });
          } catch(err){
            this.isLoading = false;
            this.$alert('Resource Request Timed Out','Approval Hierarchy','error')
          }
        },
        async updateApprovalHierarchy(){
          try {
              this.isLoading = true;
              let objApprovalData = {};
              objApprovalData.objectType = this.approvalObject;
              objApprovalData.createdby = this.createdby;
              objApprovalData.projectkey = 'cargoautoallocation'

              objApprovalData.userHierarchyData = [];
              for (var i = 0; i < this.approvelData.length; i++) {
                let userData = [];
                let temp = {}
                //objApprovalData.userHierarchyData.levelNumber = i;

                for (var j = 0; j < this.approvelData[i].userId.length; j++) {
                  let userObjTemp = {};
                  if (this.approvelData[i].userId[j].id) {
                    userObjTemp.id = this.approvelData[i].userId[j].id;
                  }
                  userObjTemp.userID = parseInt(this.approvelData[i].userId[j].value);
                  userObjTemp.userName = this.approvelData[i].userId[j].text;
                  if (this.approvelData[i].userId[j].useremail) {
                    userObjTemp.userEmail = this.approvelData[i].userId[j].useremail;
                  }else {
                    userObjTemp.userEmail = this.approvelData[i].userId[j].email;
                  }
                  userObjTemp.roleID = this.approvelData[i].roleId;
                  userObjTemp.status = 1;
                  let valueArr  = await this.rolesList.find(o => parseInt(o.roleid) == this.approvelData[i].roleId);
                  userObjTemp.roleName = valueArr.rolename;
                  userData.push(userObjTemp);
                }
                temp.levelNumber = i+1;
                temp.userData = userData;
                if (this.approvelData[i].isSendEmail == true) {
                  temp.isSendEmail = 1;
                }else {
                  temp.isSendEmail = 0;
                }
                objApprovalData.userHierarchyData.push(temp);
              }

              let result = await MasterService.updateRole(objApprovalData);
              this.isLoading = false;
              if (result.data.code == 200) {


                this.$alert("Record saved successfully.",'Approval Hierarchy','success');
                this.buttonText = 'Save';
                this.approvelData =[{
                  roleId : '',
                  roleError : '',
                  userId : [],
                  userList : [],
                  userError  :'',
                  isSendEmail : 0
                }];
                this.getApprovalHierarchyRole();
              }else {
                this.$alert('Resource Request Timed Out','Approval Hierarchy','error')
              }

          } catch(err){
            this.isLoading = false;
            this.$alert('Resource Request Timed Out','Approval Hierarchy','error')
          }
        },
        async onSubmit() {
          if (this.approvelData.length > 0) {

          let valueArr = await this.approvelData.map(function(item){
            if (item.roleId != '') {
              return parseInt(item.roleId)
            }});
          let isDuplicate = await valueArr.some(function(item, idx){
              return valueArr.indexOf(item) != idx
          });
          if (isDuplicate) {
            this.$alert("Duplicate roles not allowed please select different role.",'Approval Hierarchy', "error");
            return true;
          }else {
            let isError = 0;
            for (var i = 0; i < this.approvelData.length; i++) {
              if (this.approvelData[i].roleId == '') {
                this.approvelData[i].roleError = "Please select Role.";
                isError = 1;
              }else {
                this.approvelData[i].roleError = '';
              }
              if (this.approvelData[i].userId.length == 0) {
                this.approvelData[i].userError = "Please select User.";
                isError = 1;
              }else {
                this.approvelData[i].userError = '';
              }
            }
            if (isError == 1) {
              return true;
            }else {
              if (this.buttonText == 'Save') {
                this.saveApprovalHierarchy();
              }else {
                this.updateApprovalHierarchy();
              }
            }
          }
        }
      },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ApprovalHierarchy/approvalHierarchy/approvalHierarchy.component.js